import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import qs from 'qs';

import { fetchUserSimoDevices } from 'actions/simoDevices';
import { getUserSimoDevices, getPageCount } from 'reducers';
import SimoDevicesList from '../SimoDevicesList';
import Pagination from 'components/Pagination/Pagination';
import { Link, withRouter } from 'react-router-dom';
import { isB2b, isResold } from 'helpers/user';

export class UserSimoDevices extends Component {
  componentDidMount() {
    this.loadDevices();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.page !== this.props.page) {
      this.loadDevices();
    }
  }

  loadDevices = async () => {
    const { page, userId, fetchUserSimoDevices } = this.props;
    try {
      await fetchUserSimoDevices(page, userId);
    } catch (e) {
      toast.error('Failed to load simo devices');
    }
  };

  getNextPage = (page) => {
    const { location } = this.props;
    const paginationKey = 'simoDevicesPage';
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    query[paginationKey] = page;

    const searchParams = new URLSearchParams(query);
    return `${location.pathname}?${searchParams.toString()}`;
  };

  render() {
    const { simoDevices, userId, user, page, pageCount } = this.props;
    const isAddress = Boolean(user?.address?.length);
    const isB2bUser = isB2b(user);
    const isResoldUser = isResold(user);

    const showAddDevice =
      user?.is_active && (isB2bUser || isResoldUser) && isAddress;
    return (
      <div id="simo-devices">
        <div className="d-flex-vc mar-t" style={{ marginBottom: '10px' }}>
          <h3 style={{ marginTop: 0, marginBottom: 0 }}>Simo Devices</h3>
          {showAddDevice && (
            <div className="mar-l">
              <Link to={`/users/${userId}/simo/new-device`}>
                <button className="btn btn-default">Add Simo Device</button>
              </Link>
            </div>
          )}
        </div>
        <SimoDevicesList
          simoDevices={simoDevices}
          viewUrl={(id) => `/simo/devices/${id}/view`}
          showUserId={false}
        />
        <Pagination count={pageCount} current={page} url={this.getNextPage} />
      </div>
    );
  }
}

const mapStateToProps = (state, { userId, location }) => {
  const { simoDevicesPage = '1' } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const simoDevices = getUserSimoDevices(state, userId, simoDevicesPage);
  return {
    page: simoDevicesPage,
    pageCount: getPageCount(
      state,
      'simoDevices',
      `fetchUserSimoDevices_${userId}_`,
      simoDevicesPage,
    ),
    simoDevices,
  };
};

const mapDispatchToProps = {
  fetchUserSimoDevices,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserSimoDevices),
);
